import { useState } from 'react'
import { cn } from 'lib/utils'
import { FormError } from 'components/atoms/FormError'
import { Icon } from 'components/atoms/Icon'
import type { InputHTMLAttributes } from 'react'

const mainClass = 'form'

export interface PasswordInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'className' | 'type'
> {
  error?: string
  className?: string
}

export const PasswordInput = ({
  error,
  className,
  ...inputProps
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <div className={cn(`${mainClass}__group`)}>
      <div className={cn(`${mainClass}__password-wrapper`)}>
        <input
          {...inputProps}
          type={showPassword ? 'text' : 'password'}
          className={cn(`${mainClass}__control`, className)}
        />
        <button
          type="button"
          className={cn(`${mainClass}__password-toggle`)}
          onClick={handleTogglePassword}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          <Icon name={showPassword ? 'eye-off' : 'eye'} />
        </button>
      </div>
      {error && <FormError message={error} />}
    </div>
  )
}
